import { render, staticRenderFns } from "./ParcelamentoRemessa.vue?vue&type=template&id=7f0454b9"
import script from "./ParcelamentoRemessa.vue?vue&type=script&lang=js"
export * from "./ParcelamentoRemessa.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports